/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProvisioningNotificationResponse } from './provisioningNotificationResponse';


export interface ProvisioningNotificationBulkResponse { 
    provisioning_notifications?: Array<ProvisioningNotificationResponse>;
    total_record_count?: number;
}

